import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "../components/footer";
import Header from "../components/header";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const ComplaintHandling = () => {
  return (
    <div className="flex flex-col w-full min-h-screen">
      <Header />
      <div className="bg-[#031602] flex-1 pt-20">
        <div className="container mx-auto px-4 py-8 text-white">
          <div className="rounded-lg">
            <h1 className="text-4xl font-medium pb-10 text-center bg-gradient-to-b from-white to-[#50B553] bg-clip-text text-transparent relative">
              Xử lí khiếu nại
            </h1>
          </div>
          {/* main content */}
          <div className="text-base font-light flex flex-col gap-5">
            {/* section 1 */}
            <div>
              <h5 className="font-medium">1. Mục đích và cam kết</h5>
              <p>
                Tại chatme.vn, chính tôi luôn đặt trải nghiệm và quyền lợi của
                khách hàng lên hàng đầu. Chính sách xử lý khiếu nại này nhằm đảm
                bảo mọi ý kiến, thắc mắc hoặc khiếu nại liên quan đến dịch vụ mà
                chính tôi cung cấp đều được tiếp nhận, giải quyết nhanh chóng -
                minh bạch - công bằng.
              </p>
            </div>
            {/* section 2 */}
            <div>
              <h5 className="font-medium">2. Phạm vi áp dụng</h5>
              <p>
                Chính sách này áp dụng đối với tất cả khách hàng sử dụng sản
                phẩm và dịch vụ do Công ty CP Giải pháp và Công nghệ Giáo dục
                Cyber Uni cung cấp.
              </p>
            </div>
            {/* section 3 */}
            <div>
              <h5 className="font-medium">3. Nguyên tắc xử lý khiếu nại</h5>
              <ul className="list-disc list-inside ml-4">
                <li>
                  Công bằng - minh bạch: Mọi khiếu nại đều được xem xét khách
                  quan, không thiên vị.
                </li>
                <li>
                  Nhanh chóng - đúng hạn: Chúng tôi cam kết xử lý và phản hồi
                  trong thời gian sớm nhất.
                </li>
                <li>
                  Bảo mật - an toàn: THông tin khiếu nại được bảo mật tuyệt đối
                  và chỉ phục vụ mục đích giải quyết vụ việc.
                </li>
                <li>
                  Khắc phục - cải thiện: Nếu khiếu nại là hợp lý, chúng tôi sẽ
                  có biện pháp xử lý, bồi hoàn hoặc nâng cấp dịch vụ phù hợp.
                </li>
              </ul>
            </div>
            {/* section 4 */}
            <div>
              <h5 className="font-medium">4. Quy trình xử lý khiếu nại</h5>
              <div className="flex flex-col gap-5">
                <div>
                  <p>Bước 1: Tiếp nhận khiếu nại</p>
                  <p>
                    Khách hàng có thể gửi khiếu nại thông qua một trong các kênh
                    sau:
                  </p>
                  <div className="flex items-center gap-2 ml-8">
                    <img
                      src="/media/images/icon/email.png"
                      alt="email icon"
                      className="size-4"
                    />
                    <p>Email: support@cyberuni.vn</p>
                  </div>
                  <div className="flex items-center gap-2 ml-8">
                    <img
                      src="/media/images/icon/telephone.png"
                      alt="telephone icon"
                      className="size-4"
                    />
                    <p>Hotline hỗ trợ: 0862595658</p>
                  </div>
                  <p>
                    Lưu ý: Khi gửi khiếu nại, khách hàng cần cung cấp thông tin:
                    tên tài khoản / email đăng ký, dịch vụ/gói đang sử dụng, nội
                    dung chi tiết vấn đề và minh chứng liên quan (nếu có).
                  </p>
                </div>
                <div>
                  <p>Bước 2: Xác nhận tiếp nhận</p>
                  <p>
                    Trong vòng 24 giờ làm việc kể từ khi nhận được khiếu nại,
                    đội ngũ hỗ trợ của chúng tôi sẽ xác nhận tiếp nhận và gửi mã
                    theo dõi để khách hàng tiện tra cứu tiến trình xử lý.
                  </p>
                </div>
                <div>
                  <p>ước 3: Kiểm tra & xử lý</p>
                  <p>
                    Bộ phận kỹ thuật và chăm sóc khách hàng sẽ xác minh nguyên
                    nhân của sự cố / tranh chấp trong vòng 3 – 5 ngày làm việc.
                  </p>
                  <p>
                    Trong trường hợp phức tạp cần thêm thời gian, chúng tôi sẽ
                    thông báo rõ lý do và thời hạn dự kiến cho khách hàng.
                  </p>
                </div>
                <div>
                  <p>Bước 4: Phản hồi & giải quyết</p>
                  <p>
                    Kết quả xử lý sẽ được thông báo qua email hoặc gọi điện trực
                    tiếp.
                  </p>
                  <p>Nếu khiếu nại được xác nhận là hợp lý, chúng tôi sẽ:</p>
                  <ul className="list-disc list-inside ml-4">
                    <li>Khắc phục lỗi kỹ thuật hoặc sự cố dịch vụ.</li>
                    <li>
                      Gia hạn thêm thời gian sử dụng dịch vụ (nếu dịch vụ bị
                      gián đoạn do lỗi hệ thống).
                    </li>
                    <li>
                      Hoàn phí hoặc bồi hoàn theo chính sách (đối với trường hợp
                      nghiêm trọng)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* seciton note */}
            <div>
              <div className="flex items-center gap-2">
                <img
                  src="/media/images/icon/check.png"
                  alt="check icon"
                  className="size-4"
                />
                <p>Cam kết của chúng tôi</p>
              </div>
              <p>
                Chúng tôi hiểu rằng việc khiếu nại xuất phát từ mong muốn được
                phục vụ tốt hơn. Vì vậy, Chatme.vn luôn coi trọng từng phản hồi
                để không ngừng hoàn thiện dịch vụ, đảm bảo mang lại giải pháp AI
                hiệu quả – ổn định – an toàn nhất cho khách hàng.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ComplaintHandling;
